class DynamicBundleItem extends HTMLElement{
  constructor(){ 
    super() 
  }

  connectedCallback() {
    this.content = Array.from(this.querySelectorAll(`[bundle-component-content]`))
    this.select = this.querySelector(`[bundle-component-select]`)
    if(!this.select){
      return console.error(`dynamic-bundle-item missing select.`)
    }
    
    this.select.addEventListener(`change`, (e) => {
      this.update()
    })
    document.addEventListener("DOMContentLoaded", () => {
      this.update()
    })
  }
  update(){
    const selectedOption = Array.from(this.select.options).find(option => option.selected)
    if(!selectedOption) return console.error(`No option selected`);
    
    this.content.forEach(content => {
      if(selectedOption.dataset.optionId == content.getAttribute('bundle-component-content')){
        content.classList.remove('hidden')
      }
      else{
        content.classList.add('hidden')
      }
    })
  }
}
customElements.define(`dynamic-bundle-item`, DynamicBundleItem)

document.addEventListener('DOMContentLoaded', () => {
  const bundleDataElement = document.querySelector('#bundle-data')
  const bundleData = JSON.parse(bundleDataElement?.innerHTML ?? "null")
  if(!bundleData){
    return console.error(`[Bundle Builder] Could not load bundle data.`)
  }
  
  const bundleAvailable = Object.values(bundleData.componentAvailability).every(value => value == true)
  const form = document.querySelector(`#${bundleData.productFormId}`)
  if(!form){
    return console.error(`[Bundle Builder] Could not find product form.`)
  }
  const addToCartButtons = form.querySelectorAll(`button[type="submit"]`)

  for(const addToCartButton of addToCartButtons){
    const buttonContent = addToCartButton.querySelector('.button-content')
     if(!buttonContent){
      return console.error(`[Bundle Builder] Could not find button content`)
    }
  
    if(!bundleAvailable){
      addToCartButton.setAttribute('disabled', 'disabled')
      buttonContent.innerHTML = bundleData.soldOutButtonLabel
    }
  }
})

